import type { ProductListItem } from "../../types/Product";

export function getGuestDealPrice(product: ProductListItem): number {
  const history = Array.isArray(product.storePrice) ? product.storePrice : [];
  for (let index = history.length - 1; index >= 0; index -= 1) {
    const value = Number(history[index]);
    if (Number.isFinite(value) && value > 0) return value;
  }
  return Number(product.onlinePrice) > 0 ? Number(product.onlinePrice) : 0;
}

export function getGuestDealDiscount(product: ProductListItem): number {
  const price = getGuestDealPrice(product);
  const msrp = Number(product.msrp) || 0;
  if (product.discountPercentage > 0) return Math.round(product.discountPercentage);
  return msrp > price && price > 0 ? Math.round(((msrp - price) / msrp) * 100) : 0;
}

export function getSafeAffiliateDestination(value: string, fallback: string) {
  try {
    const parsed = new URL(value);
    if (parsed.protocol === "https:" && !parsed.username && !parsed.password) {
      return value;
    }
  } catch {
    /* Fall back to the retailer URL. */
  }
  return fallback;
}
